import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import './../../main.css'
import { withNamespaces } from 'react-i18next';
import { Row } from 'react-bootstrap';
import { Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

export class AmountByCountry extends React.Component{
    render(){  
        const { t } = this.props
     
        const CustomTooltip = ({ active, payload, label }) => {
            
            if (active && payload && payload.length) {
                return (
                    <div className="custom-tooltip">
                        <p >{`${label}`}</p>
                        <p> {t('With PDV')} : {`${payload[1].value.toFixed(2)}`}</p>
                        <p >{t('Without PDV')} : {`${payload[0].value.toFixed(2)}`}</p>
                    </div>
                );
            }
        
            return null;
        };

        const renderLegend = (props) => {
            const { payload } = props;

            return (
              <ul key={1}>
                {
                  payload.map((entry, index) => (                    
                    <li key={index}><div key={index + 1} className="square me-4"></div>{index === 0 ? t('Without PDV') : t('With PDV')}</li>
                  ))
                }
              </ul>
            );
          }

        return(    
            <Row className="total_users">
                <span className="mb-2">{t('Amount by country')}</span>
                <div className="p-2" id="tabs">
                    <BarChart
                        width={500}
                        height={300}
                        data={this.props.list}
                        margin={{
                            top: 10,
                            right: 30,
                            left: -15,
                            bottom: 5,
                        }}
                        >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="countryName" />
                        <YAxis />
                        <Tooltip content={<CustomTooltip />} />      
                        <Legend content={renderLegend} />
                        {/* <Legend /> */}
                        <Bar
                            dataKey="amountWithoutPdv"
                            stroke="#000000"
                            strokeWidth={1}
                        >
                        {
                            this.props.list.map((entry, index) => (
                                <Cell key={`cell-${index}`} className="withoutPDV"/>
                            ))
                        }
                        </Bar>
                        <Bar
                            dataKey="amountWithPdv"
                            stroke="#000000"
                            strokeWidth={1}
                        >
                        {
                            this.props.list.map((entry, index) => (
                                <Cell key={`cell-${index}`} className="withPDV"/>
                            ))
                        }
                        </Bar>   
                    </BarChart>
                </div>  
            </Row>
        )
    }  
}

const mapStateToProps = state => {
    return {
        list: state.dashboard.amountByCountry
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(AmountByCountry));
